import { render, staticRenderFns } from "./PlaceDetail.vue?vue&type=template&id=5c4a94fe&scoped=true&"
import script from "./PlaceDetail.vue?vue&type=script&lang=js&"
export * from "./PlaceDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlaceDetail.vue?vue&type=style&index=0&id=5c4a94fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a94fe",
  null
  
)

export default component.exports